import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'pme-apolo',
      storage,
      whitelist: ['menuLeft'],
    },
    reducers
  );
  return persistedReducer;
};
